import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	uploadConfiguration: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.upload-configuration',
		defaultMessage: 'Upload File',
		description: 'Upload configuration file',
	},
	uploadConfigurationAccordionHeading: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.upload-configuration-accordion-heading',
		defaultMessage: 'Upload a configuration file (optional)',
		description: 'Upload configuration accordion heading',
	},
	uploadConfigurationDescription: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.upload-configuration-description',
		defaultMessage:
			'Adding a <link>configuration</link> file will use the import settings used previously. You can edit these settings further if required.',
		description: 'Upload configuration accordion description',
	},
});
